module.exports = __webpack_public_path__ + "img/flare.16f3486e.svg";